import { useMutation } from "@tanstack/react-query";
import { callApi } from "../../utils/ApiCallPostOnly";

export const useSaveReturn = () => {
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "savereturnorder",
        command: "",
        data: JSON.stringify(data),
      }),
  });
};
